// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3c8ap","tab":"ProcedureTabs_tab__1frY9"};